/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import { ETheme } from '@datatype/type';
import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
import { TAdminSortOrder, TAdminSourceSort } from '@datatype/admin/api-type';
import TextBlock from '@component/common/block/text-block';
import Chip from '@design-system/chip';

interface IProps {
  languageCode: EApiLanguageCode | null;
  sortBy: TAdminSourceSort | null;
  sortOrder: TAdminSortOrder;
  handleChange: (languageCode: EApiLanguageCode | null) => void;
  handleSortClick: (sortBy: TAdminSourceSort) => void;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

const Group = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  align-items: center;
`;

const sortLabel = (sortBy: TAdminSourceSort, current: TAdminSourceSort | null, order: TAdminSortOrder) => {
  const base = sortBy === 'releaseDate' ? 'Release Date' : 'Checked At';
  if (sortBy !== current) return base;
  return `${base} ${order === 'asc' ? '↑' : '↓'}`;
};

const ExpressionSourceFilter: React.FC<IProps> = ({
  languageCode,
  sortBy,
  sortOrder,
  handleChange,
  handleSortClick,
}) => {
  return (
    <Wrapper>
      <Group>
        <TextBlock text='언어' design={{ text: { size: 'small', color: color.BLACK_4 } }} />
        <Chip
          text='전체'
          size='small'
          isSelected={languageCode === null}
          handleClick={() => handleChange(null)}
          theme={ETheme.BROWN}
        />
        <Chip
          text='EN'
          size='small'
          isSelected={languageCode === EApiLanguageCode.ENGLISH}
          handleClick={() => handleChange(EApiLanguageCode.ENGLISH)}
          theme={ETheme.BROWN}
        />
        <Chip
          text='JA'
          size='small'
          isSelected={languageCode === EApiLanguageCode.JAPANESE}
          handleClick={() => handleChange(EApiLanguageCode.JAPANESE)}
          theme={ETheme.BROWN}
        />
      </Group>
      <Group>
        <TextBlock text='정렬' design={{ text: { size: 'small', color: color.BLACK_4 } }} />
        <Chip
          text={sortLabel('releaseDate', sortBy, sortOrder)}
          size='small'
          isSelected={sortBy === 'releaseDate'}
          handleClick={() => handleSortClick('releaseDate')}
          theme={ETheme.BROWN}
        />
        <Chip
          text={sortLabel('checkedAt', sortBy, sortOrder)}
          size='small'
          isSelected={sortBy === 'checkedAt'}
          handleClick={() => handleSortClick('checkedAt')}
          theme={ETheme.BROWN}
        />
      </Group>
    </Wrapper>
  );
};

export default ExpressionSourceFilter;
